import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img
              src="img/about.jpg"
              className="img-responsive"
              alt=""
              style={{
                borderRadius: 50,
                boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)",
              }}
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Sobre Nosotros</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <p>{props.data ? props.data.paragraph2 : "loading..."}</p>

              <a href="#services" className="btn btn-custom btn-lg">
                Descúbrelas
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
